import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminAuth from "./dashbaordAdmin/oAuth";
import AdminHomePage from "./dashbaordAdmin/HomePage";
import ProtectedRoute from "./dashbaordAdmin/ProtectedRoute";
import QrCodeUrl from "./pages/qrCodeUrl";
import ThankYouImage from "./components/thankYouImage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<ThankYouImage />} />
        <Route path="/qr-code" element={<QrCodeUrl />} />
        <Route path="/admin/login" element={<AdminAuth />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminHomePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
